const employerLength = (value) => {
  if (!value) {
    return true;
  }
  return value.length > 2 && value.length <= 40;
};
export default employerLength;
